// Authentication Loading Component

import React from 'react';
import { useTranslation } from 'react-i18next';

export const AuthLoading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">{t('auth.initializing')}</p>
      </div>
    </div>
  );
};
